import React, { useEffect, useState } from "react";
import { Alert, Box, Button, Card, Modal, Progress, Text } from "~/components-shared";
import Markdown from "~/components/Markdown";
import styled from "styled-components";
import api from "~/lib/api";
import { handleError } from "~/lib/helpers";
import { useTranslation } from "react-i18next";
import StyledIcon from "~/components/StyledIcon";
const Overflow = styled.div`
  overflow: hidden;
  max-height: 240px;
  position: relative;

  &:after {
    content: "";
    height: 100px;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background: ${_ref => {
  let {
    theme
  } = _ref;
  return theme.colors.gradients.background(180);
}};
  }
`;
const StyledButton = styled(Button)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
const LearnMoreButton = styled(Button)`
  position: absolute;
  bottom: 0.5em;
  left: 50%;
  transform: translateX(-50%);
`;
const StyledAlert = styled(Alert)`
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
  overflow: hidden;
`;
const SummaryCard = _ref2 => {
  let {
    dateFrom,
    dateTo,
    topicIds,
    widget,
    ...rest
  } = _ref2;
  const {
    t
  } = useTranslation();
  const [summary, setSummary] = useState(widget?.data?.summary);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(undefined);
  const [open, setOpen] = React.useState(false);
  const handleFetchSummary = () => {
    setLoading(true);
    setError(undefined);
    api.fetchInsightsSummary({
      dateFrom,
      dateTo,
      topicIds
    }).then(response => {
      setSummary(response);
    }).catch(e => {
      setError(handleError(e));
    }).finally(() => {
      setLoading(false);
    });
  };
  useEffect(() => {
    if (!widget?.data?.summary) {
      handleFetchSummary();
    } else {
      setSummary(widget?.data?.summary);
    }
  }, [dateFrom, dateTo, topicIds, widget?.data?.summary]);
  return /*#__PURE__*/React.createElement(Card, rest, /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    fontSize: 8,
    s: {
      mb: 3
    }
  }, t("SummaryCard.wdyntk")), error && /*#__PURE__*/React.createElement(StyledAlert, {
    severity: "danger",
    fullWidth: true
  }, error), summary ? summary === "No line items during this period" ? /*#__PURE__*/React.createElement(Box, {
    direction: "column",
    justify: "center",
    align: "center",
    fullHeight: true
  }, /*#__PURE__*/React.createElement(StyledIcon, {
    src: "infoOutline",
    color: "translucentInfo"
  }), /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    weight: "semiBold",
    display: "block",
    s: {
      mt: 6
    },
    align: "center",
    style: {
      maxWidth: "300px"
    }
  }, "Nothing was identified during this period")) : /*#__PURE__*/React.createElement(Overflow, null, /*#__PURE__*/React.createElement(Markdown, {
    fontSize: 4,
    lineHeight: 6,
    text: summary,
    linkColor: "primary"
  }), summary.length > 400 && /*#__PURE__*/React.createElement(LearnMoreButton, {
    color: "primaryGrey",
    onClick: () => setOpen(true),
    s: {
      px: 4,
      py: 1.5
    },
    fontSize: 3.5,
    rounded: true
  }, "Read more")) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Progress, {
    s: {
      mb: 2
    },
    height: 5,
    maxWidth: "100%"
  }), /*#__PURE__*/React.createElement(Progress, {
    s: {
      mb: 2
    },
    height: 5,
    maxWidth: "95%"
  }), /*#__PURE__*/React.createElement(Progress, {
    s: {
      mb: 2
    },
    height: 5,
    maxWidth: "30%"
  }), /*#__PURE__*/React.createElement(Progress, {
    s: {
      mb: 2
    },
    height: 5,
    maxWidth: "80%"
  }), /*#__PURE__*/React.createElement(Progress, {
    s: {
      mb: 2
    },
    height: 5,
    maxWidth: "95%"
  }), /*#__PURE__*/React.createElement(Progress, {
    s: {
      mb: 2
    },
    height: 5,
    maxWidth: "30%"
  }), /*#__PURE__*/React.createElement(Progress, {
    s: {
      mb: 2
    },
    height: 5,
    maxWidth: "100%"
  }), /*#__PURE__*/React.createElement(Progress, {
    s: {
      mb: 2
    },
    height: 5,
    maxWidth: "80%"
  })), /*#__PURE__*/React.createElement(StyledButton, {
    color: "primary",
    onClick: handleFetchSummary,
    loading: loading,
    fontSize: 4,
    s: {
      px: 4,
      py: 3
    }
  }, t("SummaryCard.getSummary"))), /*#__PURE__*/React.createElement(Modal, {
    open: open
  }, /*#__PURE__*/React.createElement(Modal.Body, {
    title: "What you need to know",
    onClose: () => setOpen(false),
    maxWidth: "800px",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Modal.Content, null, /*#__PURE__*/React.createElement(Markdown, {
    fontSize: 4,
    lineHeight: 6,
    text: summary,
    linkColor: "primary"
  })))));
};
export default SummaryCard;